/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component} from '@angular/core';

@Component({
    selector: 'app-custom-button-cell',
    templateUrl: './custom-button-cell.component.html',
    styleUrl: './custom-button-cell.component.scss',
    standalone: false
})
export class CustomButtonCellComponent {
  params: any;
  icon: string;

  agInit(params: any): void {
    this.params = params;
    this.icon = params.icon;
  }

  /**
   * Onclick method used for the onclick event of the button
   */
  onClick(): void {
    if (this.params.onClick instanceof Function) {
      // Pass the cell data to the callback function
      const cellData = {
        rowData: this.params.node.data,
        colDef: this.params.colDef
      };
      this.params.onClick(cellData.rowData);
    }
  }
}
